import { render, staticRenderFns } from "./genVariables.vue?vue&type=template&id=997efe64&"
import script from "./genVariables.vue?vue&type=script&lang=js&"
export * from "./genVariables.vue?vue&type=script&lang=js&"
import style0 from "./genVariables.vue?vue&type=style&index=0&id=997efe64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports